import { render } from "./HandlingTypeForm.vue?vue&type=template&id=72ada52e"
import script from "./HandlingTypeForm.vue?vue&type=script&lang=js"
export * from "./HandlingTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__